import { createApp } from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import Toast from 'vue-toastification';
import { createGtm } from 'vue-gtm';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import http from './http';
import meta from './meta';
import './styles/vue-toastification.css';
import TextInterpolate from './helpers/TextInterpolate';
import hookupNotifications from './helpers/hookupNotifications';
import createGtmStub from './helpers/createGtmStub';

const app = createApp(App).use(store).use(router);

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new VueIntegration({
        Vue: app,
        attachProps: true,
      }),
    ],
  });
}

app.use(Toast, {
  //
});

const gtmId = process.env.VUE_APP_GTM_ID;

if (gtmId) {
  app.use(
    createGtm({
      id: gtmId,
      queryParams: {
        // Add url query string when load gtm.js with GTM ID (optional)
      },
      defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: process.env.NODE_ENV !== 'production', // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    }),

  );

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    in_standalone: (window.matchMedia('(display-mode: standalone)').matches) ? 'y' : 'n',
  });
} else {
  app.config.globalProperties.$gtm = createGtmStub();
}

// eslint-disable-next-line no-underscore-dangle
window.__localeId__ = 'nl';

app.provide('$http', http);
app.provide('$meta', meta);

app.config.globalProperties.$textInterpolate = new TextInterpolate();

hookupNotifications();

app.mount('#app');
